let _ = require("ES/lib/lodash");

let removeTime = function(d_orig){
	let d = new Date();
	d.setTime(0);
	// We have to set the date in this order (Year -> Date -> Month) to account for
	// leap years because in most years setting the date to February 29th results
	// in it being March 1st
	d.setFullYear(d_orig.getFullYear());
	d.setDate(d_orig.getDate());
	d.setMonth(d_orig.getMonth());
	return d;
};

let getDate = function(o, key){
	if(_.isDate(o && o[key]) && !_.isNaN(o[key].getTime())){
		return removeTime(o[key]);
	}
	return undefined;
};

module.exports = function(result){
	let start = getDate(result, 'stagetime_starttime');
	let stop = getDate(result, 'stagetime_stoptime');

	if(!start && !stop){
		return [];
	}else if(start && !stop){
		return [start];
	}else if(!start && stop){
		return [stop];
	}else if(start > stop){
		let tmp = start;
		start = stop;
		stop = tmp;
	}

	let r = [];
	while(start < stop){
		r.push(new Date(start));
		start.setDate(start.getDate() + 1);
	}
	r.push(new Date(stop));

	return r;
};



// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/TreeSearch/getResultDates.js